export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    favicon.dataset.defaultHref =
      window.currentFaviconUrl || favicon.dataset.defaultHref || favicon.href;
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        favicon.href =
          window.currentFaviconUrl ||
          favicon.dataset.defaultHref ||
          window.globalConfig?.LOGO_THUMBNAIL ||
          favicon.href;
      });
    }
  });
};
